module.exports = __webpack_public_path__ + "static/media/07.f6589853.jpg";